import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import { AuthProvider } from "./authContext"; // Import AuthProvider from your AuthContext file
import "./App.css";
import Home from "./pages/Home";
import Uses from "./pages/Uses";
import Resume from "./pages/Resume";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Contact from "./pages/Contact";

import ProtectedRoute from "./components/ProtectedRoute";

function App() {
	return (
		<Router>
			<AuthProvider>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/uses" element={<Uses />} />
					
					<Route path="/resume" element={<Resume />} />
					<Route path="/login" element={<Login />} />
					<Route path="/contact" component={<Contact/>} />
					<Route
						path="/admin"
						element={
							<ProtectedRoute>
								<Admin />
							</ProtectedRoute>
						}
					/>
					<Route path="*" element={<Navigate to="/" />} />
				</Routes>
			</AuthProvider>
		</Router>
	);
}

export default App;
